import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { MitpManagerService } from "../../services/mitp-manager.service";
import { SecureGuard } from "../../guards/secure.guard";

/** The sent emails page is for supreme admins only, behind the same MFA check as the admin pages. */
export const sentEmailsGuard: CanActivateFn = () => {
	if (!inject(MitpManagerService).isAdmin()) {
		return inject(Router).createUrlTree(["/"]);
	}
	return inject(SecureGuard).canActivate();
};
